/** Роли клуба BaySport (зеркало backend/utils/roles.js). */

const LEGACY = { doctor: "trainer", patient: "client" };

export function normalizeRole(role) {
  return LEGACY[role] || role;
}

export function isClientRole(role) {
  return normalizeRole(role) === "client";
}

export function isTrainerRole(role) {
  const r = normalizeRole(role);
  return r === "trainer" || r === "owner";
}

export function hasAdminAccess(role) {
  const r = normalizeRole(role);
  return r === "admin" || r === "owner";
}

export function hasTrainerAccess(role) {
  const r = normalizeRole(role);
  return r === "trainer" || r === "owner";
}

export function isOwner(role) {
  return normalizeRole(role) === "owner";
}

export function isClubStaff(role) {
  const r = normalizeRole(role);
  return hasAdminAccess(r) || r === "trainer";
}

export function staffNavRole(role) {
  const r = normalizeRole(role);
  if (r === "owner") return "admin";
  return r;
}
